import React from "react";
import ReactDOM from "react-dom";
import { calc } from "../../../js/chips-common";
import "../../../assets/fonts/font.css";

export function ChipsPopup(props, children) {
  props.popupId = `chips-popup-${Date.now()}`;
  props.children = children;

  props.dismiss = (popupId) => {
    const container = document.getElementById("chips-popup-container");
    const popupContainer = container.lastChild;
    const popup = popupContainer?.firstChild;
    if (popup && popup.id === props.popupId) {
      window.history.back();
    }
  };

  render(props);
}

function render(props) {
  const container = document.getElementById("chips-popup-container");
  const popupContainer = document.createElement("div");
  popupContainer.id = props.popupId + "-container";
  container.appendChild(popupContainer);

  ReactDOM.render(component(props), popupContainer, () => {
    setTimeout(() => {
      const popup = popupContainer?.firstChild;
      if (!popup) return;

      popup.style.opacity = 1;
      popup.firstChild.style.scale = 1;
    }, 100);
  });

  window.history.pushState({}, "");

  window.onpopstate = () => {
    const container = document.getElementById("chips-popup-container");
    const popupContainer = container.lastChild;
    const popup = popupContainer?.firstChild;
    if (!popup) return;

    popup.style.opacity = 0;
    const content = popup.firstChild;
    if (content.style.transform) {
      content.style.transform = "translateY(100%)";
    } else {
      content.style.scale = 0.95;
    }

    setTimeout(() => {
      try {
        ReactDOM.unmountComponentAtNode(popupContainer);
        container.removeChild(popupContainer);
      } catch (e) {}
    }, 100);
  };
}

function component(props) {
  return (
    <div
      id={props.popupId}
      style={{
        background: "rgba(0, 0, 0, 0.40)",
        position: "fixed",
        width: "100%",
        height: "100%",
        zIndex: "5",
        transitionProperty: "all",
        transition: ".1s ease-in-out",
        opacity: 0,
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "fixed",
          width: calc(280),
          borderRadius: calc(10),
          background: "#FFF",
          scale: "0.95",
          transitionProperty: "all",
          transition: ".1s ease-in-out",
        }}
      >
        {props.children ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingBottom:
                props.secondaryButtonText || props.primaryButtonText
                  ? calc(50)
                  : 0,
            }}
          >
            {props.children}
          </div>
        ) : (
          <div
            className="scrollbar-hidden"
            onTouchMove={(event) => {
              event.stopPropagation();
            }}
            style={{
              maxHeight: `calc(100vh - ${calc(
                40,
              )} - var(--safe-area-inset-bottom))`,
              overflow: "scroll",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingBottom:
                  props.secondaryButtonText || props.primaryButtonText
                    ? calc(50)
                    : 0,
                marginBottom: calc(20),
              }}
            >
              <div
                style={{
                  width: calc(200),
                  marginTop: calc(20),
                  padding: `0 ${calc(16)}`,
                  color: "#3D3D3D",
                  textAlign: "center",
                  fontFamily: "Spoqa Han Sans Neo",
                  fontSize: calc(18),
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "150%",
                  flex: "1 0 0",
                }}
              >
                {props.title}
              </div>

              <div
                style={{
                  position: "absolute",
                  top: calc(15),
                  right: calc(8),
                  padding: calc(8),
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (!props.close || !props.close()) {
                    props.dismiss();
                  }
                }}
              >
                <img
                  style={{
                    width: calc(20),
                    height: calc(20),
                  }}
                  src="/games/fruits/assets/ic-title-back.png"
                />
              </div>

              {props.image ? (
                <div
                  style={{
                    width: calc(200),
                    marginTop: calc(16),
                  }}
                >
                  <img
                    style={{
                      width: "100%",
                    }}
                    src={props.image}
                  />
                </div>
              ) : null}

              {props.message ? (
                <div
                  style={{
                    color: "#3D3D3D",
                    textAlign: "center",
                    fontFamily: "Spoqa Han Sans Neo",
                    fontSize: calc(15),
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "150%",
                    padding: `0 ${calc(16)}`,
                    marginTop: calc(16),
                  }}
                  dangerouslySetInnerHTML={{ __html: props.message }}
                ></div>
              ) : null}
            </div>
          </div>
        )}

        {props.secondaryButtonText || props.primaryButtonText ? (
          <div
            style={{
              width: "100%",
              height: calc(50),
              display: "flex",
              flexDirection: "row",
              color: "#FFFFFF",
              textAlign: "center",
              fontFamily: "Spoqa Han Sans Neo",
              fontSize: calc(16),
              fontStyle: "normal",
              fontWeight: "700",
              lineHeight: "140%",
              borderRadius: `0 0 ${calc(10)} ${calc(10)}`,
              overflow: "hidden",
              position: "absolute",
              bottom: 0,
            }}
          >
            {props.secondaryButtonText ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "100%",
                  background: "#BDBDBD",
                  flex: "1 0 0",
                  cursor: "pointer",
                  transitionProperty: "all",
                  transition: ".1s ease-in-out",
                }}
                onClick={() => {
                  if (
                    !props.secondaryButtonAction ||
                    !props.secondaryButtonAction()
                  ) {
                    props.dismiss();
                  }
                }}
                dangerouslySetInnerHTML={{ __html: props.secondaryButtonText }}
              ></div>
            ) : null}

            {props.primaryButtonText ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "100%",
                  background: "#FF514E",
                  flex: "1 0 0",
                  cursor: "pointer",
                  transitionProperty: "all",
                  transition: ".1s ease-in-out",
                }}
                onClick={() => {
                  if (
                    !props.primaryButtonAction ||
                    !props.primaryButtonAction()
                  ) {
                    props.dismiss();
                  }
                }}
                dangerouslySetInnerHTML={{ __html: props.primaryButtonText }}
              ></div>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
